// src/analytics/gtm.js
// Minimal GTM loader. Plays nicely with existing window.dataLayer / gtag.

// Helper to check if we're on production domain
function isProduction() {
  return process.env.REACT_APP_DOMAIN === "permitrockstar.app";
}

export function loadGTM(containerId) {
  if (!isProduction() || typeof window === "undefined") return;
  if (!containerId) {
    return;
  }
  if (window.__gtmLoaded) return;

  // Ensure dataLayer exists (gtag.js already creates this; this is safe)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
  document.head.appendChild(s);

  window.__gtmLoaded = true;
}
